

































































import {
  computed,
  defineComponent,
  onMounted,
  ref,
  useContext,
  useRouter,
} from '@nuxtjs/composition-api';
import { SfBreadcrumbs } from '@storefront-ui/vue';

import { useApi } from '~/composables';
import { Breadcrumb } from '~/modules/catalog/types';

import { IBrandList } from './brand-type';
import { queryBrandsList } from './queryBrand.gql';

export default defineComponent({
  name: 'Brand',
  components: {
    SfBreadcrumbs,
  },
  setup() {
    const {
      localePath,
      app: { i18n },
    } = useContext();
    const router = useRouter();
    const { query } = useApi();
    const { app } = useContext();
    const { isDesktop } = app.$device;

    const brandList = ref<IBrandList<Number | string | undefined>>();
    const brandAlphabet = ref<Array<String>>([]);
    const breadcrumbs = ref<Breadcrumb[]>([
      {
        text: i18n.t('Home') as string,
        link: localePath('/'),
      },
      {
        text: i18n.t('Brand') as string,
        link: localePath('/brand'),
      },
    ]);
    onMounted(async () => {
      try {
        const { data } = await query<any>(queryBrandsList);
        if (data && data.ambrandlist) {
          const { ambrandlist } = data;
          brandList.value = {
            all_letters: ambrandlist.all_letters,
            items: ambrandlist.items,
          };
          brandAlphabet.value = ambrandlist.all_letters.split(
            ','
          ) as Array<String>;
        }
      } catch (error) {
        console.log(error);
      }
    });

    const handleRouter = (brand) => {
      const { brandId: brandRef, label: name } = brand;
      const newName = name ? name.replaceAll(' ', '-') : null;
      router.push({ path: `/brand/${newName}`, query: { brands: brandRef } });
    };

    const groupedBrandObject = computed(() => {
      if (!brandList.value) return null;
      return brandList.value?.items.reduce((grouped: any, brand: any) => {
        const letter = brand?.letter;
        if (!grouped[letter]) {
          grouped[letter] = [];
        }
        grouped[letter].push(brand);
        return grouped;
      }, {});
    });

    return {
      breadcrumbs,
      brandAlphabet,
      brandList,
      groupedBrandObject,
      isDesktop,
      handleRouter,
    };
  },
  data() {
    return {
      isShowNav: false,
      isShowMobileNav: false,
    };
  },
  created() {
    if (process.client) {
      window.addEventListener('scroll', this.handleScroll);
    }
  },
  destroyed() {
    if (process.client) {
      window.removeEventListener('scroll', this.handleScroll);
    }
  },
  methods: {
    handleScroll() {
      if (process.client) {
        const currentScrollPosition = window.scrollY;

        if (currentScrollPosition > 64) {
          this.isShowNav = true;
        } else {
          this.isShowNav = false;
        }
      }
    },
    clickAlpha(k) {
      this.$refs.singleBrand[k].scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    },
  },
});
